<template>
  <div>
    <el-dialog
      v-el-drag-dialog
      custom-class
      :close-on-click-modal="false"
      :visible.sync="innerVisible"
      :title="$t('AdvancePayment.InitializeBalance')"
      width="1120px"
      @close="innerVisible=false"
    >
      <div class="app-main-inner-row row-grid" style="padding: 0;">
        <cargo-ag-grid
          :show-side-bar="false"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
          :style="{width:'100%',height:'500px'}"
        />
      </div>
      <div slot="footer">
        <el-button type="primary" no="confirm" @click="confirm">{{ $t('CargoMsg.Cargo_ConfirmR') }}</el-button>
        <el-button no="cancel" @click="() =>{innerVisible=false}">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ColumnUtils from '@/utils/ColumnUtils'
import { getLoading } from '@/utils/utilBaseElement'
import { formatNumberToThousands } from '@/utils'
import { queryInitializeBalance, saveInitializeBalance } from '@/api/clearing/advancePayment'

export default {
  name: 'ShowInitBalancesDialog',
  props: {
    visible: { type: Boolean, required: true },
    customerCodes: { type: Array, required: true, default: () => [] }
  },
  data() {
    return {
      loading: false,
      innerVisible: false,
      gridOptions: {},
      gridParams: {},
      gridApi: {},
      columnDefs: [
        { headerName: this.$t('AdvancePayment.CustomerCode'), field: 'custCode', initialWidth: 130, minWidth: 130 },
        { headerName: this.$t('AdvancePayment.CustomerName'), field: 'custName', initialWidth: 200, minWidth: 200 },
        { headerName: this.$t('AdvancePayment.CustSettlement'), field: 'custSettlement', initialWidth: 120, minWidth: 120,
          cellRenderer: (params) => {
            return ColumnUtils.AdvancePaymentCustSettlementLabelFun(params.value)
          }
        },
        { headerName: this.$t('AdvancePayment.InstCode'), field: 'instCode', initialWidth: 120, minWidth: 120 },
        { headerName: this.$t('AdvancePayment.InstName'), field: 'instName', initialWidth: 140, minWidth: 140 },
        { headerName: this.$t('AdvancePayment.SrcSystem'), field: 'srcSystem', initialWidth: 100, minWidth: 100 },
        { headerName: this.$t('AdvancePayment.AdvBalance'), field: 'advBalance', initialWidth: 140, minWidth: 140,
          cellRenderer: (params) => {
            return formatNumberToThousands(ColumnUtils.number2ColumnLabelFunc(params.value), 2)
          }
        },
        { headerName: this.$t('AdvancePayment.OrderType'), field: 'orderType', initialWidth: 120, minWidth: 120,
          cellRenderer: (params) => {
            return ColumnUtils.AdvancePaymentOrderTypeLabelFun(params.value)
          }
        }
      ],
      sideBarDefs: { toolPanels: ['columns', 'filter'], visible: false },
      rowData: []
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (newVal) {
        this.toQuery()
      }
    },
    innerVisible(newVal) {
      if (!newVal) {
        this.rowData = []
      }
      this.$emit('update:visible', newVal)
    }
  },
  created() {
    if (this.visible) {
      this.innerVisible = true
      this.toQuery()
    }
  },
  methods: {
    toQuery() {
      if (!this.customerCodes || this.customerCodes.length === 0) {
        return
      }
      this.loading = getLoading()
      queryInitializeBalance(this.customerCodes).then(res => {
        this.rowData = res.data
      }).finally(() => {
        this.loading.close()
      })
    },
    // 确认
    confirm() {
      if (!this.rowData || this.rowData.length === 0) {
        return
      }
      this.$confirm(this.$t('CargoMsg.Cargo_AreYouSureToDo', [this.$t('AdvancePayment.InitializeBalance')]), this.$t('CargoMsg.Cargo_Tips'), {
        confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
        cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        this.doSaveInitializeBalance()
      }).catch(() => {
        //
      })
    },
    doSaveInitializeBalance() {
      this.loading = getLoading()
      saveInitializeBalance(this.rowData).then(res => {
        // this.toQuery()
        this.$message.success(this.$t('CargoMsg.Cargo_OperationComplete'))
        this.innerVisible = false
        this.$emit('initCompleted')
      }).finally(() => {
        this.loading.close()
      })
    }
  }
}
</script>

<style lang="scss">
.el-loading-mask.is-fullscreen {
  z-index: 999999 !important;
}
</style>
